export class UnitOfMeasure {
    id: number;
    measureType: string;
}

export class SiteInformation {
    id: number;
    siteId: number;
    measureTypeId: number;
    measureType: string;
    productionSize: number;
    warehouseSize: number;
    officeSize: number;
    manufacturingEmployeeNo: number;
    engineerEmployeeNo: number;
}

export class Commodity {
    id: number;
    description: string;
}

export class MenuOption {
    id: number;
    description: string;
}

export class ProductMaterial {
    toolId: number;
    classId: number;
    className: string;
    gradeId: number;
    gradeName: string;
}

export class ServiceCapability {
    internalProductionCapable = false;
    internalProductionTimeNeeded: number | null;
    internalPrototypeCapable = false;
    internalPrototypeTimeNeeded: number | null;
    outsourceProductionCapable = false;
    outsourceProductionTimeNeeded: number | null;
    outsourcePrototypeCapable = false;
    outsourcePrototypeTimeNeeded: number | null;
}

export class ProductExperienceTool {
    id: number;
    productExperienceId: number;
    categoryId: number;
    subCategoryId: number;
    isTool: boolean;
    toolId: number;
    toolName: string;
    materials: ProductMaterial[] = []
    buildService = new ServiceCapability();
    maintainService = new ServiceCapability();
    repairService = new ServiceCapability();
    toolType: number;
}

export class ProductExperience {
    id: number;
    siteId: number;
    commodityId: number;
    commodityDescription: string;
    experienceYears: number | null;
    totalParts: number | null;
    revenuePercentage: number | null;
    volume: number | null;
    quoteWeeks: number | null;
    doesProduction: boolean | null;
    doesPrototype: boolean | null;
    tools: ProductExperienceTool[] = [];
    equipments: ProductExperienceTool[] = [];
}
